module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAShJREFUWIXtl9tRwzAQRc9m+Ccd4BLcAS4lHUAHpARKCBUEOrArACqIUwHu4PJhaSZPbEmOmAmcn5VmdrV3vJJXgn8ckpaSNrosa0nFueS52Eia+9wzZxd5vjMABVAeCrjLKACg8oObhEU+gS4ytt2bBdawk1QlCD8mUMBiytwxJaj9QFIJ3MYmN7PG3EIKCLIdATVwnyDAZsNul+UqBWyBxtnsAhqgNLOK/m/3llvA0sw6AGefcwsIZmoBT77TOfswFJDSC05RAe+SWvquV+QWwNjEnqvbA8EEl0BSYWatmz4C8x/cRy/6a+04RsCXJryQBLfjHT6Iv5K9mNkK0o5hOexylsYP/CkY1bkmpD4UsMqYfEtfvn3Uv47awA0ZQifpVaeeZn+ab0X8PwLoA3WnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_wallet.png
// module id = 362
// module chunks = 1